define.alias("ember-composable-helpers/helpers/join", "calendar/helpers/join");